/* eslint-disable jsx-a11y/alt-text */
import React from "react";
import Api from "../../../../services/ServiceApi";
import { Input, DatePicker } from "antd";
import moment from "moment";
import Cookies from "js-cookie";

// const dateFormatList = ["DD/MM/YYYY", "DD/MM/YY"];
// const { RangePicker } = DatePicker;
// const { Option } = Select;
const { TextArea } = Input;
const content = {
  startdate: {
    label: "Start Date",
    value: "",
  },
  madate: {
    label: "Ma Date",
    value: "",
  },
  informby: {
    label: "Inform By",
    value: "",
  },
  jobdetail: {
    label: "Job Detail",
    value: "",
  },
  remark: {
    label: "Remark",
    value: "",
  },
  sla: {
    label: "SLA Level",
    value: "",
    option: [
      { label: "xx", value: "xx" },
      { label: "xxx", value: "xxx" },
      { label: "xxxx", value: "xxxx" },
    ],
  },
  priority: {
    label: "Priority",
    value: "",
    option: [
      { label: "x", value: "x" },
      { label: "xx", value: "xx" },
      { label: "xxx", value: "xxx" },
    ],
  },
};
export default function ProblemDetail({
  title,
  formdata,
  valuechange,
  selectchange,
  datepicker,
  language,
  factupdate,
  jobcategory,
  jobtypeid,
  jobcatselect,
  sla,
  slatime,
  onOk,
}) {
  formdata["informby"] = Cookies.get("username");
  const locale = Cookies.get("locale");
  const priority = jobcatselect;
  return (
    <div
      className="col-lg-7 mt-4 pb-5 mr-4 ml-4"
      style={{ backgroundColor: "#FFFFFF", borderRadius: "5px" }}
    >
      <div className="row mt-3">
        <img src={Api.absoluteUrl("/icon/job_detail.svg")}></img>
        <span className="font-thai-b fs-22 ml-2 mb-1">{title}</span>
      </div>
      <div className="row mt-3">
        <div className="col-12">
          <div className="row">
            <div className="col-lg-4">
              <div className="row">
                <span className="font-thai-r fs-18 c-gray">
                  {factupdate
                    ? language[locale]["date_start"]
                    : content.startdate.label}
                  <b style={{ color: "#DF4547" }}> * </b>
                </span>
              </div>
              <div className="row">
                <DatePicker
                  disabled={formdata.IsHold || false}
                  showTime={{ format: "HH:mm" }}
                  defaultValue={
                    formdata.startdate !== ""
                      ? moment(
                          formdata.startdate === null
                            ? new Date()
                            : formdata.startdate
                        )
                      : null
                  }
                  format="YYYY-MM-DD HH:mm:ss"
                  onChange={datepicker}
                  onOk={onOk}
                  style={{ width: "100%", color: "#000f9f !important" }}
                  className="inputfile c-blue"
                />
              </div>
            </div>
            <div className="col-lg-4">
              <div className="row">
                <span className="font-thai-r fs-18 c-gray">
                  {factupdate
                    ? language[locale]["inform_name"]
                    : content.informby.label}
                </span>
              </div>
              <div className="row">
                <Input
                  name="informby"
                  disabled
                  value={formdata.informby}
                  onChange={valuechange}
                  className="inputfile c-blue"
                ></Input>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-lg-10">
              <div className="row mt-2">
                <span className="font-thai-r fs-18 c-gray">
                  {factupdate
                    ? language[locale]["job_detail"]
                    : content.jobdetail.label}
                </span>
              </div>
              <div className="row">
                <TextArea
                  disabled={formdata.IsHold || false}
                  name="jobdetail"
                  className="inputfile c-blue"
                  value={formdata.jobdetail}
                  onChange={valuechange}
                  rows={4}
                ></TextArea>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-lg-10">
              <div className="row mt-2">
                <span className="font-thai-r fs-18 c-gray">
                  {factupdate
                    ? language[locale]["remark"]
                    : content.remark.label}
                </span>
              </div>
              <div className="row">
                <TextArea
                  disabled={formdata.IsHold || false}
                  name="remark"
                  className="inputfile c-blue"
                  value={formdata.remark}
                  rows={4}
                  onChange={valuechange}
                ></TextArea>
              </div>
            </div>
          </div>

          {/* <div className="row text-nowrap" style={{ marginLeft: "11%" }}>
            <div className="col-3 mr-3">
              <div className="row">
                <span className="font-thai-r c-gray fs-18">
                  {factupdate
                    ? language[locale]["sla_level"]
                    : content.sla.label}
                </span>
              </div>
              <div className="row text-nowrap">
                <Select
                  name="slalevel"
                  className="dropdrowtype font-thai-r"
                  defaultValue={formdata.slalevel}
                  style={{ width: "100%" }}
                  onChange={selectchange.bind(this, "slalevel")}
                >
                  {sla.map((data, index) => (
                    <Option key={index} value={`${data.job_sla_id}_${index}`}>
                      {data.sla_name}
                    </Option>
                  ))}
                </Select>
              </div>
            </div>
            <div className="col-2 mr-2">
              <div className="row">
                <span className="font-thai-r c-gray fs-18">
                  {factupdate
                    ? language[locale]["standard_day"]
                    : `standard_day`}
                </span>
              </div>
              <div className="row">
                <Input
                  name="sla_time_day"
                  disabled
                  value={slatime.sla_time_day}
                  onChange={valuechange}
                ></Input>
              </div>
            </div>
            <div className="col-2 mr-2">
              <div className="row">
                <span className="font-thai-r c-gray fs-18">
                  {factupdate
                    ? language[locale]["Standard Hour"]
                    : `Standard Hour`}
                </span>
              </div>
              <div className="row">
                <Input
                  disabled
                  name="sla_time_hour"
                  value={slatime.sla_time_hour}
                  onChange={valuechange}
                ></Input>
              </div>
            </div>
            <div className="col-2 mr-2">
              <div className="row">
                <span className="font-thai-r c-gray fs-18">
                  {factupdate
                    ? language[locale]["standard_minute"]
                    : `standard_minute`}
                </span>
              </div>
              <div className="row">
                <Input
                  disabled
                  name="sla_time_min"
                  value={slatime.sla_time_min}
                  onChange={valuechange}
                ></Input>
              </div>
            </div>
          </div> */}
          {/* <div className="row">
            <div className="col-8" style={{ marginLeft: "12.5%" }}>
              <div className="row">
                <span className="font-thai-r c-gray fs-18">
                  {factupdate
                    ? language[locale]["priority"]
                    : content.priority.label}
                </span>
              </div>
              <div className="row">
                <Select
                  name="priority"
                  className="dropdrowtype font-thai-r"
                  defaultValue={formdata.priority}
                  onChange={selectchange.bind(this, "priority")}
                  style={{ width: "58%" }}
                >
                  {priority.map((data, index) => (
                    <Option
                      key={`priority_form_add_job${index}`}
                      value={data.priority_id}
                    >
                      {data.priority_name}
                    </Option>
                  ))}
                </Select>
              </div>
            </div>
          </div> */}
        </div>
      </div>
    </div>
  );
}
